import * as React from "react";
import { observer } from "mobx-react";
import { Affix, Button, Group, Paper, Stack, Text, Title } from "@mantine/core";
import { useStores } from "@/hooks/useStores";

export const Gdpr = observer(() => {
    const { playerStore, userStore } = useStores();

    const approve = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        userStore.setGdprApproved(true);
    };

    const bottomOffset = playerStore.active ? 96 : 16;

    return !userStore.gdprApproved ? (
        <Affix position={{ bottom: bottomOffset, left: 16, right: 16 }} zIndex={20000}>
            <Paper mx="auto" p="lg" radius="sm" shadow="xl" maw={720} withBorder>
                <Stack gap="sm">
                    <Title order={4}>Cookies och analys</Title>
                    <Text size="sm">
                        Vi sparar information på din klient i form av cookies och liknande mekanismer. Vi använder även
                        analysverktyg där icke-personlig användardata sparas för att hjälpa oss att se hur tjänsten
                        används och förenkla att avhjälpa eventuella fel som kan uppstå i tjänsten.
                    </Text>
                    <Group justify="flex-end">
                        <Button color="teal" onClick={approve}>
                            Det är ok med mig
                        </Button>
                    </Group>
                </Stack>
            </Paper>
        </Affix>
    ) : null;
});
